import { withTranslation } from 'react-i18next';
import { Fragment, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import imagesLoaded from 'imagesloaded';

import config from 'config/config.json';

import styles from './TommyTeaser.module.scss';

import Buttons from 'components/Buttons';
import NFT from 'components/NFT';

import orangeRip from './img/orange_paper_rip.png';
import photoBgSm from './img/photo_bg_sm.jpg';
import photoBgLg from './img/photo_bg.jpg';
import img1 from './img/teaser_01.png';
import img2 from './img/teaser_02.png';
import img3 from './img/teaser_03.png';
import brandTextRepeat from 'assets/images/blue_text.png';
import tape from './img/tape.png';
import blueRip from './img/blue_paper_rip.jpg';

import logo from 'assets/images/tommyXTimberlandLogo.png';

const {showNFTModule} = config;

const TommyTeaser = ({children, t}) => {
	const location = useLocation();
	const nftRef = useRef(null)

	useEffect(() => {

    imagesLoaded(
    	document.body, 
    	{ background: true },
    	() => {
				if (location.pathname.toLowerCase().includes('nft')) {
					setTimeout(() => {
						nftRef && nftRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
					}, 200);
				}
    	}
  	)
	}, [location]);

	return (
		<div className={styles.tommy_wrap}>
			{/* Starts Top Section */}
			<div className={styles.teaser_top}>
				<div className={styles.orange_rip}>
					<img src={orangeRip} alt="" />
				</div>
				<div className={styles.photo_bg}>
					<img src={photoBgSm} className={styles.photo_bg_sm} alt="" />
					<img src={photoBgLg} className={styles.photo_bg_lg} alt="" />
				</div>
			</div>
			{/* Starts Top Section */}

			{/* Starts Logo/Photo Section */}
			<div className={styles.images}>
				<img src={logo} alt="Tommy X Timberland Logo" className={styles.logo} />
				<div className={styles.images_inner}>
					<div className={styles.image1}>
						<img src={img1} alt="Teaser" />
					</div>
					<div className={styles.image2}>
						<img src={img2} alt="Teaser" />
					</div>
					<div className={styles.image3}>
						<img src={img3} alt="Teaser" />
					</div>
				</div>
			</div>
			{/* Starts Logo/Photo Section */}

			{/* Starts Text Section */}
			<section className={styles.teaser_text}>
				<h1>{t('module-one-hed')}</h1>
				<p>{t('module-one-sub')}</p>
				<Buttons data-analytics data-action="click_cta" data-label="signup_tommytimberland" data-category="general" onClick={() => window.open(t('module-one-cta-mens-url'))} width="170px" color="#fff" background="#042068" children={t('module-one-cta-mens')} style={{ 'marginTop': '20px', 'paddingLeft': '10px', 'paddingRight': '10px' }} />
				<Buttons data-analytics data-action="click_cta" data-label="signup_tommytimberland" data-category="general" onClick={() => window.open(t('module-one-cta-womens-url'))} width="170px" color="#fff" background="#042068" children={t('module-one-cta-womens')} style={{ 'marginTop': '20px', 'paddingLeft': '10px', 'paddingRight': '10px' }} />
			</section>
			{/* Ends Text Section */}

			{/* Starts Bottom Section */}
			<div className={styles.teaser_bottom}>
				<div className={styles.blue_rip}>
					<img src={blueRip} alt="" />
				</div>
				{showNFTModule && (
					<Fragment>
						<section ref={nftRef} className={styles.nft_text}>
							<h1>{t('module-two-hed')}</h1>
							<p>{t('module-two-sub')}</p>
						</section>
						<section className={styles.nft_wrapper}>
							<NFT lightVersion={true} showText={false} showInfoTab={false} />
							{/* <Buttons onClick={() => window.open(t('module-one-cta-mens-url'))} width="170px" color="#042068" background="#fff" children={t('module-one-cta-mens')} style={{ 'marginTop': '20px', 'paddingLeft': '10px', 'paddingRight': '10px' }} />
							<Buttons onClick={() => window.open(t('module-one-cta-womens-url'))} width="170px" color="#042068" background="#fff" children={t('module-one-cta-womens')} style={{ 'marginTop': '20px', 'paddingLeft': '10px', 'paddingRight': '10px' }} /> */}
						</section>
					</Fragment>
				)}

				<div className={styles.left_tape}>
					<img src={tape} alt="" />
				</div>
				<div className={styles.right_tape}>
					<img src={tape} alt="" />
				</div>
				<div className={styles.brand_text}>
					<img src={brandTextRepeat} alt="" /> 
				</div>
			</div>
			{/* Ends Bottom Section */}
		</div>
	)
}

export default withTranslation()(TommyTeaser);